import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24BoldG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M12.6 20c3.36 0 5.4-1.73 5.4-4.546 0-2.118-.918-3.681-3.056-3.892q-.054.006-.054-.042 0-.047.054-.047c1.615-.266 2.292-1.763 2.292-3.481C17.236 5.563 15.393 4 12.535 4H6.622A.623.623 0 0 0 6 4.622v14.756c0 .343.279.622.622.622zm-1.21-9.347H9.08a.266.266 0 0 1-.266-.266V6.495c0-.147.119-.266.266-.266h2.744c1.68 0 2.63.787 2.63 2.184 0 1.486-1.102 2.24-3.066 2.24zm.566 7.118H9.081a.267.267 0 0 1-.266-.266v-4.336c0-.148.119-.267.266-.267h2.755c2.16 0 3.295.722 3.295 2.352 0 1.641-1.102 2.517-3.175 2.517"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24BoldG$1 = Svg24BoldG;

export { Svg24BoldG$1 as default };
